import { OnInit, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { LogisticsEmpsDivComponent } from '../logistics-emps-div/logistics-emps-div.component';
import { LogisticsEmpsDetailComponent } from '../logistics-emps-detail/logistics-emps-detail.component';
import { EsLogisticsService } from 'src/app/restapi/be-esquery';
import { DEFAULT_FORMATS, dateFormat } from 'src/app/share/utils/common-utils';
import { take } from 'rxjs/operators';
import * as XLSX from 'xlsx';
import * as _moment from 'moment';
var moment = _moment;
var ɵ0 = DEFAULT_FORMATS;
var LogisticsEmpsComponent = /** @class */ (function () {
    function LogisticsEmpsComponent(fb, esLogisticsService) {
        this.fb = fb;
        this.esLogisticsService = esLogisticsService;
        this.minDate = moment().add(-3, 'month');
        this.maxDate = moment();
    }
    LogisticsEmpsComponent.prototype.ngOnInit = function () {
        this.initForm();
    };
    LogisticsEmpsComponent.prototype.ngOnDestroy = function () { };
    LogisticsEmpsComponent.prototype.initForm = function () {
        this.form = this.fb.group({
            gte_date: this.minDate,
            lte_date: this.maxDate,
            dept_info: null,
            areas: null
        });
    };
    Object.defineProperty(LogisticsEmpsComponent.prototype, "fc_gteDate", {
        get: function () { return this.form.get('gte_date'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LogisticsEmpsComponent.prototype, "fc_lteDate", {
        get: function () { return this.form.get('lte_date'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LogisticsEmpsComponent.prototype, "fc_deptInfo", {
        get: function () { return this.form.get('dept_info'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LogisticsEmpsComponent.prototype, "fc_areas", {
        get: function () { return this.form.get('areas'); },
        enumerable: true,
        configurable: true
    });
    LogisticsEmpsComponent.prototype.onChangeStartDate = function () {
        var limitDate = moment(this.fc_gteDate.value).add(3, 'month');
        this.minDate = this.fc_gteDate.value;
        if (this.fc_gteDate.value > this.fc_lteDate.value) {
            this.fc_lteDate.setValue(this.fc_gteDate.value);
        }
        if (limitDate < this.fc_lteDate.value) {
            this.fc_lteDate.setValue(limitDate);
        }
    };
    LogisticsEmpsComponent.prototype.onChangeEndDate = function () {
        var limitDate = moment(this.fc_lteDate.value).add(-3, 'month');
        if (limitDate > this.fc_gteDate.value) {
            this.fc_gteDate.setValue(limitDate);
            this.minDate = limitDate;
        }
    };
    LogisticsEmpsComponent.prototype.selectDept = function (value) {
        if (!value || value == null) {
            this.fc_deptInfo.setValue(null);
            return;
        }
        this.fc_deptInfo.setValue(value);
        this.search();
    };
    LogisticsEmpsComponent.prototype.selectAreas = function (value) {
        if (!value || value == null) {
            this.fc_areas.setValue(null);
            return;
        }
        this.fc_areas.setValue(value);
        this.search();
    };
    LogisticsEmpsComponent.prototype.search = function () {
        this.logisticsEmpsGet();
    };
    LogisticsEmpsComponent.prototype.exportTOExcel = function () {
        var ws_div = XLSX.utils.table_to_sheet(this.divComp.table.nativeElement);
        var ws_detail = XLSX.utils.table_to_sheet(this.detailComp.table.nativeElement);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws_div, '운전자별 순환지원 통계1');
        XLSX.utils.book_append_sheet(wb, ws_detail, '운전자별 순환지원 통계2');
        XLSX.writeFile(wb, '운전자별 순환지원 통계.xlsx');
    };
    LogisticsEmpsComponent.prototype.logisticsEmpsGet = function () {
        var _this = this;
        this.esLogisticsService.logisticsEmpsGet(dateFormat(this.fc_gteDate.value), dateFormat(this.fc_lteDate.value), this.fc_deptInfo.value != null ? this.fc_deptInfo.value.dept_id : null, this.fc_areas.value != null ? this.fc_areas.value.sk : null).pipe(take(1)).subscribe(function (res) {
            _this.logisticsEmpsStatistics = res;
        }, function (err) { console.error(err); });
    };
    return LogisticsEmpsComponent;
}());
export { LogisticsEmpsComponent };
export { ɵ0 };
